import { useEffect, type ReactElement, type ReactNode } from 'react';

export function Modal({
  title,
  onClose,
  children,
  width,
}: {
  title: string;
  onClose: () => void;
  children: ReactNode;
  width?: number;
}): ReactElement {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal"
        style={width ? { maxWidth: width } : undefined}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <div className="modal-head">
          <h2>{title}</h2>
          <button className="icon-btn" aria-label="Close" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
}

export function CopyField({ value, label }: { value: string; label?: string }): ReactElement {
  const copy = () => {
    void navigator.clipboard.writeText(value);
  };
  return (
    <div className="copy-field">
      {label ? <label>{label}</label> : null}
      <div className="copy-row">
        <code className="copy-value">{value}</code>
        <button className="btn small" onClick={copy}>
          Copy
        </button>
      </div>
    </div>
  );
}
